import React from 'react';
import { Section } from './Section';
export function Problem() {
  return <Section data-id="element-145">
      <h2 className="font-display font-bold text-3xl md:text-5xl mb-8 text-center uppercase tracking-tight" data-id="element-146">
        El problema no es que seas "demasiado sensible" o que "tengas mala
        suerte"
      </h2>

      <div className="max-w-3xl mx-auto space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-147">
        <p data-id="element-148">
          El problema es que tu sistema nervioso está cableado para la
          supervivencia, no para el placer prolongado. Tu cerebro primitivo
          interpreta la excitación como una situación de "ataque" y dispara el
          reflejo eyaculatorio lo más rápido posible.
        </p>
        <p data-id="element-149">
          Has intentado todo: pensar en fútbol, usar condones gruesos, tomar
          alcohol para "aguantar" o incluso comprar pastillas con efectos
          secundarios peligrosos.
        </p>
        <div className="bg-brand-gray/20 p-6 md:p-8 border-l-4 border-brand-blue mt-8" data-id="element-150">
          <p className="font-bold text-white m-0" data-id="element-151">
            Nada ha funcionado porque estás tratando de apagar un incendio
            forestal con un vaso de agua. Estás atacando los síntomas, no la
            causa raíz biológica.
          </p>
        </div>
      </div>
    </Section>;
}